module.exports = __webpack_public_path__ + "assets/img/icon5.c6c3907d.svg";